<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, PAYMENT_TYPE} from "../lib/constants";
    import {lastDateOfMonth} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";


    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    let search = {
        date_from: null,
        date_to: null,
        payment_type: PAYMENT_TYPE.ON_ACCOUNT,
    }
    let report = null;

    const validate = () => {
        if (!search.date_from || !search.date_to) {
            Notifier.showError("Select dates for the report!");
            return false;
        }

        return true;
    }

    const load = () => {
        const onSuccess = result => {
            report = result;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.transporter, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onExport = () => {

        if (!validate()) {
            return;
        }

        const extra = `?report=transporter&` + new URLSearchParams(search);
        window.open(API_URL + '/export.php' + extra);
    }
</script>
<PageHeader title="Transporter Reports" controls={ pageHeaderControls } on:export={ onExport }/>

<div class="panel-simple p-2 mb-4">
    <div class="row">
        <div class="col-lg-2 col-sm-3 col-6">
            <DateControl bind:value="{ search.date_from }" placeholder="from" on:change={ onDateFromChange }/>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <div class="form-item">
                <DateControl bind:value="{ search.date_to }" placeholder="to"/>
            </div>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
            <select class="form-select" bind:value="{ search.payment_type }">
                <option value="{ PAYMENT_TYPE.ON_ACCOUNT}">On Account</option>
                <option value="{ PAYMENT_TYPE.CASH }">Cash</option>
                <option value="{ PAYMENT_TYPE.CARD }">Credit Card</option>
                <option value="{ PAYMENT_TYPE.BANK }">Bank Deposit</option>
            </select>
        </div>
        <div class="col-xl-2 col-sm-3 col-12">
            <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
        </div>
    </div>
</div>

{#if report}
    <div class="row">
        <div class="col-md-6 col-12">
            <table class="table table-list table-list-border trans-list mb-4">
                <thead>
                <tr>
                    <th colspan="4">
                        <b>{ report.payment_type }</b><br>
                        from { report.from } to { report.to }
                    </th>
                </tr>
                <tr>
                    <th>TRANSPORTER</th>
                    <th class="text-end">TOTAL</th>
                    <th class="text-end">NET</th>
                    <th class="text-end">VAT</th>
                </tr>
                </thead>
                <tbody>
                {#each report.transporters as transporter}
                    <tr>
                        <td>{ transporter.name }</td>
                        <td class="text-end">{ transporter.total_price }</td>
                        <td class="text-end">{ transporter.total_net }</td>
                        <td class="text-end">{ transporter.total_vat }</td>
                    </tr>
                {/each}
                <tr>
                    <td colspan="4" class="row-separator"></td>
                </tr>
                <tr>
                    <td class="fw-semibold">SUM</td>
                    <td class="fw-semibold text-end">{ report.total_price }</td>
                    <td class="fw-semibold text-end">{ report.total_net }</td>
                    <td class="fw-semibold text-end">{ report.total_vat }</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
{/if}

<style>
    .trans-list .row-separator {
        height: 5px;
        padding: 0;
    }
</style>